import React, { useState } from "react";
import {  Dash, Plus } from "react-bootstrap-icons";

import CustomerCareImg from "../../../assets/images/customer-care.png";

const Faq = () => {
  const [currentFaq, setCurrentFaq] = useState(0);
  const faqs = [
    {
      title: "What is Ileero Remit?",
      content: (
        <div>
          <p className="mb-0 mt-3">
            Ileero Remit is a Fintech institution that offers money transfer
            services.
          </p>
          <p className="m-0">
            It was designed to give customers an easier and seamless way to
            financial remittances via digital payments.
          </p>
          <p className="m-0">
            With an Ileero Remit account, you can send and receive money from
            the United Kingdom to India and African Countries including Nigeria,
            Ghana, Uganda, Tanzania, and Kenya.
          </p>
        </div>
      ),
    },
    {
      title: "How do I register?",
      content: (
        <div>
          <p className="mb-1 mt-3">
            Step 1: Download the Ileero Remit app from the Google Play Store or
            Apple Store.
          </p>
          <p className="mb-1">
            Step 2: Open the app, enter your email address, create a password,
            log in, and complete verification to be able to make transfers.
          </p>
          <p className="m-0">
            Step 3: Verify your account using your facial recognition and an
            approved form of ID. Accounts are verified using Shuftipro. You are
            registered once you have successfully completed and passed the
            verification process.
          </p>
        </div>
      ),
    },
    {
      title: "How long does it take to open an account?",
      content: (
        <p className="mb-0 mt-3">
          It takes less than two minutes to register, Once your details are
          correct and has been confirmed.
        </p>
      ),
    },
    {
      title: "What countries does Ileero Remit support?",
      content: (
        <p className="mb-0 mt-3">
          You can send and receive money from the United Kingdom to African,
          Asian and South American countries like Nigeria, India, Columbia, etc.
        </p>
      ),
    },
    {
      title: "What payment method do we accept?",
      content: (
        <div>
          <p className="mb-1 mt-3">
            We accept payment by Visa and Mastercard debit cards and credit
            cards, as well as bank transfer and open payment . Payment limits
            may apply depending on your bank and payment method.
          </p>
          <p className="mb-0">
            We do not accept payment by cash, cheque or any payment method
            that’s not listed above.
          </p>
        </div>
      ),
    },
    {
      title: "How do I keep track of a transfer?",
      content: (
        <p className="mb-1 mt-3">
          We will send you email notifications throughout the transfer process:
          when we receive your funds, when any foreign exchange transaction has
          occurred, and when we send the funds to your beneficiary.
        </p>
      ),
    },
  ];
  return (
    <div className="py-5 container" id="help">
      <div className="row my-4 align-items-center">
        <div className="col-lg-6">
          <img src={CustomerCareImg} alt="" width="100%" />
        </div>
        <div className="col-lg-5">
          <h2 className="text-primary"></h2>
          <h5 className="">
            Our customer services team is available 24/7 to help you with
            anything you need.
          </h5>
          <p>
            customer care hotline:{" "}
            <span className="text-secondary">+4420 3011 2409</span> and{" "}
            <span className="text-secondary">+44800 254 5034</span>
          </p>

          <p>
            Our support website:{" "}
            <a
              className="text-secondary"
              href="https://support.ileeroremit.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://support.ileeroremit.com/
            </a>{" "}
          </p>

          <p>
            Facebook, Twitter, Instagram:{" "}
            <span className="text-secondary">@ileerorpay</span>{" "}
          </p>

          <p>
            Whatsapp: <span className="text-secondary">+447878815401</span>
          </p>
        </div>
      </div>
      {/* <div className="row justify-content-center m-0"> */}
      {/* <div className="col-lg-6 text-center">
          <h3 className="font-weight-bold text-dark">FAQ</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam
          </p>
        </div> */}
      {/* </div> */}
      <div className="row justify-content-center mt-5" id="faqs">
        <div className="col-lg-8 mt-5">
          <h1 className="font-weight-bold text-primary text-center">
            Everything you need to know about sending money with Ileero Remit
          </h1>
        </div>
      </div>
      <div className="row">
        {faqs.map((faq, index) => (
          <div className="col-lg-12" key={index}>
            <FaqContainer
              faq={faq}
              showContent={currentFaq === index ? true : false}
              setContentState={() => setCurrentFaq(index)}
            />
          </div>
        ))}
      </div>
      <a
        className="btn btn-primary"
        href="http://support.ileeroremit.com/"
        target="_blank"
      >
        View Other Frequently Asked Questions
      </a>
    </div>
  );
};

const FaqContainer = (props: any) => {
  const { faq, showContent } = props;
  return (
    <div className="border rounded faq my-3">
      <div
        className={`faqHeader cursor-pointer ${showContent && "border-bottom"}`}
        onClick={() => props.setContentState()}
      >
        <div className="d-flex p-2">
          <div
            className="border-right d-flex align-items-center justify-content-center mr-2"
            style={{ height: 30, width: 30 }}
          >
            {!showContent ? <Plus size={20} /> : <Dash size={20} />}
          </div>
          <div className=" d-flex align-items-center">
            <h5 className="m-0">{faq.title}</h5>
          </div>
        </div>
      </div>

      <div className={`${showContent ? "d-flex pr-3 pb-3" : "d-none"}`}>
        <div className="mr-2" style={{ height: 30, minWidth: 30 }}></div>{" "}
        {faq.content}
      </div>
    </div>
  );
};

export default Faq;
